import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketBulkAppointmentEventSubscription = () => {
  const { invalidateListCalendarEvents, invalidateListCalendarEventsByAttendee, invalidateListScheduleActivity } =
    SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  // Invalidate the list of calendar events for the date range on bulk appointment update
  return useWebsocketEventSubscription(NotificationType.BULK_APPOINTMENT_CHANGE, (payload) => {
    invalidateListCalendarEvents({
      locationId: payload.params.locationId,
      startDateTime: payload.params.startDatetime,
      endDateTime: payload.params.endDatetime,
    });
    invalidateListCalendarEventsByAttendee(payload.params.locationId);
    invalidateListScheduleActivity({ locationId: payload.params.locationId });
  });
};
